<template>
  <div>
    <el-row class="websitequerypanel">
      <el-form label-width="150px" label-position="left" >
        <el-form-item label="自定义菜单Json数据:">
          <el-input
            type="textarea"
            autosize=""
            :rows=18
            placeholder="请输入内容"
            v-model="pagecontext">
          </el-input>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-button style="margin-top: 10px" @click="savecusmenu">保存自定义菜单</el-button>
      <el-button style="margin-top: 10px; margin-left: 10px;" @click="delcusmenu">删除自定义菜单</el-button>
    </el-row>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'WxMenuSet',
  data () {
    return {
      khid: '',
      pagecontext: ''
    }
  },
  created: function () {
  },
  mounted: function () {
    that = this
    var v = getCookie('cusid')
    this.khid = v
    console.log(that)
    /*
    var jsondata = {
      'button': [
        {
          'type': 'click',
          'name': '获取OenID',
          'key': 'Get_SQOPENID_001',
          'url': 'https://api.sqnetsoft.cn/wx/getgzhopenid'
        },
        {
          'name': '菜单',
          'sub_button': [
            {
              'type': 'view',
              'name': '授权',
              'url': 'http://www.soso.com/'
            },
            {
              'type': 'view',
              'name': '支付',
              'url': 'https://api.sqnetsoft.cn/wx/pay'
            }, {
              'type': 'view',
              'name': '会员',
              'url': 'http://www.soso.com/'
            }, {
              'type': 'view',
              'name': '卡券',
              'url': 'http://www.soso.com/'
            }]
        }
      ]
    }
    console.log(jsondata)
    this.pagecontext = JSON.stringify(jsondata, null, 4)
     */
    that.$options.methods.getwxmenu()
  },
  methods: {
    getwxmenu: function () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/wx/getwxmenu',
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success || res.status === 200) {
            console.log(JSON.parse(res.data.data))
            var menutmp = JSON.parse(res.data.data)
            var newmenutmp = []
            for (var i = 0; i < menutmp.button.length; i++) {
              var subdatatmp = menutmp.button[i]
              console.log(subdatatmp)
              if (subdatatmp.sub_button) {
                subdatatmp.sub_button = subdatatmp.sub_button.list
              }
              newmenutmp.push(subdatatmp)
            }
            console.log(newmenutmp)
            var adata = {
              'button': newmenutmp
            }
            that.pagecontext = JSON.stringify(adata, null, 4)
            that.$message({
              type: 'success',
              message: '读取完毕'
            })
          } else {
            that.$message({
              type: 'error',
              message: res.data.data
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    savecusmenu: function () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/wx/createmenu',
        method: 'post',
        data: {
          minfo: this.pagecontext
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: res.data.data
            })
          } else {
            that.$message({
              type: 'error',
              message: res.data.data
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    delcusmenu: function () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/wx/delwxmenu',
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除完毕'
            })
          } else {
            that.$message({
              type: 'error',
              message: res.data.data
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/wx/WxMenuSet.vue